<div class="ipm-custom-data-table" *ngIf="colData && currentSection !== 'couponList';else couponListTemplate ">
    <div class="ipm-order-list-container">
        <div class="mb-2">
            <ng-container *ngFor="let rowData of tableData; let rowIndex = index" >
                <ipm-order-details [orderData]="rowData" [isInlineView]="true" [viewType]="currentSection === 'myorder' ? 'myOrder' : 'studioOrder'" ></ipm-order-details>
            </ng-container>
        </div>
        <div class="order-empty-state" *ngIf="!tableData || tableData.length === 0">
            <p>No customers found.</p>
        </div>
    </div>
</div>
<ng-template #couponListTemplate>
    <div class="ipm-custom-data-table">
        <p-table [columns]="colData" [value]="tableData" [tableStyle]="{ 'min-width': '50rem' }"
            styleClass="ipm-custom-table">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <ng-container *ngFor="let col of columns">
                        <th [pSortableColumn]="col.isSortableEnable ? col.field : null">
                            {{ col.header }}
                            <p-sortIcon *ngIf="col.isSortableEnable" [field]="col.field" />
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
                <tr (click)="openDetails(rowIndex)">
                    <td *ngFor="let col of columns">
                        <ng-container *ngIf="col.key === 'code'">
                            {{ rowData[col.field] }}
                        </ng-container>
                        <ng-container *ngIf="col.key === 'srNo'">
                            {{ rowIndex + 1 }}
                        </ng-container>
                        <ng-container *ngIf="col.key === 'expiryDate'">
                            {{ rowData[col.field] | date : "dd/MM/YYYY" }}
                        </ng-container>
                        <ng-container *ngIf="col.key === 'amount'">
                            <span *ngIf="rowData.discount.quantifier === 'rupee'">
                                {{(rowData.discount.value ? rowData.discount.value : 0 ) | currency:'INR' }}
                            </span>
                            <span *ngIf="rowData.discount.quantifier === 'percentage'">
                                {{rowData.discount.value || 0}}%
                            </span>
                        </ng-container>
                        <ng-container *ngIf="col.key === 'revenue'">
                            <span>{{ rowData[col.field] | currency:'INR' : 'symbol' : '1.0-0' }}</span>
                        </ng-container>
                        <ng-container *ngIf="col.key === 'feeCharges'">
                            <span>{{ rowData[col.field] | currency:'INR' : 'symbol' : '1.0-0' }}</span>
                        </ng-container>
                        <ng-container *ngIf="col.key === 'earnings'">
                            <span class="earning-text">{{ rowData[col.field] | currency:'INR' : 'symbol' : '1.0-0'
                                }}</span>
                        </ng-container>
                        <ng-container *ngIf="col.key === 'status'">
                                <span class="ipm-order-status-value" [class.ipm-complete-status]="!rowData.isExpired"
                                    [class.ipm-failed-status]="rowData.isExpired">
                                    <span *ngIf="!rowData.isExpired"><img src="./assets/imgs/check-icon.png"
                                            alt="completed-icon" width="18" height="18"> Active</span>
                                    <span *ngIf="rowData.isExpired"><img src="./assets/imgs/failed-icon.webp"
                                            alt="failed-icon" width="18" height="18"> Expired</span>
                                </span>
                        </ng-container>
                        <ng-container *ngIf="col.key === 'limit'">
                            {{ rowData.limit.redeem_count || '' }}
                        </ng-container>
                        <ng-container *ngIf="col.key === 'action'">
                            <div class="ipm-action-section" [class.ipm-price-section]="currentSection === 'couponList'">
                                <div class="ipm-button "
                                    [class.ipm-enroll-button]="!((rowData.beats && rowData.beats.length) || (rowData.sounds && rowData.sounds.length))"
                                    [class.ipm-no-event]="rowData.isExpired || rowData.isDisabled"
                                    [class.ipm-dis-enroll]="(rowData.beats && rowData.beats.length) || (rowData.sounds && rowData.sounds.length)"
                                    (click)="preventDefault($event); onClickEventTrigger(rowData)">
                                    <div class="ipm-btn-section">
                                        <span>{{((rowData.beats && rowData.beats.length > 0) || (rowData.sounds
                                            &&
                                            rowData.sounds.length > 0)) ? 'Disenroll' : 'Enroll'}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</ng-template>